import type { DataCockpitCell } from '@/types/data-cockpit';

interface DataCockpitProps {
  cells: DataCockpitCell[];
}

export function DataCockpit({ cells }: DataCockpitProps) {
  return (
    <div
      data-testid="data-cockpit"
      className="grid grid-cols-2 gap-px bg-[#3d3a35]"
    >
      {cells.map((cell, i) => (
        <div
          key={i}
          className="bg-[#252320] p-3 flex flex-col gap-1"
          data-testid={cell.testId}
        >
          {/* Icon row (optional) */}
          {cell.icon !== undefined && (
            <div className="text-[#9a9590]" aria-hidden="true">
              {cell.icon}
            </div>
          )}

          {/* Primary value */}
          {cell.primary && (
            <p
              className="text-[20px] font-bold text-[#e8e5e0] leading-tight"
              data-testid={cell.testId ? `${cell.testId}-primary` : undefined}
            >
              {cell.primary}
            </p>
          )}

          {/* Secondary value (optional) */}
          {cell.secondary !== undefined && (
            <p
              className="text-[12px] text-[#9a9590] leading-tight"
              data-testid={cell.testId ? `${cell.testId}-secondary` : undefined}
            >
              {cell.secondary}
            </p>
          )}

          {/* Badge slot (optional) — rendered after secondary */}
          {cell.badge !== undefined && (
            <div data-testid={cell.testId ? `${cell.testId}-badge` : undefined}>
              {cell.badge}
            </div>
          )}

          {/* Label */}
          <p
            className="text-[10px] uppercase tracking-widest text-[#9a9590] leading-tight mt-auto"
            data-testid={cell.testId ? `${cell.testId}-label` : undefined}
          >
            {cell.label}
          </p>
        </div>
      ))}
    </div>
  );
}
